import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-friend-invitation',
  templateUrl: './friend-invitation.component.html',
  styleUrls: ['./friend-invitation.component.scss']
})
export class FriendInvitationComponent implements OnInit {
  sectionTitle = 'Friend Invitation'
  FITitle = 'Earn 10 for charity'
  FISubtitle = 'Every time a friend joins Zenplans through your personal invitation link, we will make a 10 donation to one of our charity partners'
  FICharity = '1. Select your charity'
  FISharing = '2. Share your personal invitation link with a friend'

  FIBoxesCharity = [
    {BoxNumber: 1}, 
    {BoxNumber: 2}, 
    {BoxNumber: 3}, 
    {BoxNumber: 4}, 
    {BoxNumber: 5}
  ]

  constructor() { }

  ngOnInit() {
  }

}
